import React from 'react'
import { Modal } from 'react-bootstrap'

import { useIcaewModals } from '../hooks/useIcaewModals'
import IcaewModalSteps from './IcaewModalSteps'

interface Props {
  children: React.ReactNode
}

const IcaewModalHeader: React.FC<Props> = ({ children }) => {
  const { shouldShowStepIndicators } = useIcaewModals()

  return (
    <Modal.Header>
      <Modal.Title>
        {children}
        {shouldShowStepIndicators && <IcaewModalSteps />}
      </Modal.Title>
    </Modal.Header>
  )
}

export default IcaewModalHeader
